<script setup>
import { ElMessage } from "element-plus";
import { computed, getCurrentInstance, ref } from "vue";

const emits = defineEmits(["fileFun", "fileDel", "change"]);

const { proxy } = getCurrentInstance();

const props = defineProps({
  filesObj: {
    // 已上传文件列表
    type: Array,
    default() {
      return [];
    },
  },
  size: {
    type: Number, // size = 1 时为 multiple
    default: 3,
  },
  showFileList: {
    // 是否显示文件列表
    type: Boolean,
    default: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  text: {
    type: String,
    default: "点击上传",
  },
  accept: {
    type: String,
    default: "xlsx,xls,docx,doc,pdf",
  },
});

// 新上传的文件列表
const newFileList = ref([]);

// 删除附件
const delFiles = (item) => {
  if (item.id) {
    // eslint-disable-next-line vue/no-mutating-props
    props.filesObj.splice(
      props.filesObj.findIndex((item1) => item1 === item),
      1
    );
    emits("fileFun", null, filesId);
  } else {
    const index = newFileList.value.findIndex((item1) => item1 === item);
    newFileList.value.splice(index, 1);
    emits("fileDel", index);
  }
  emits("change", newFileList.value, props.filesObj);
  proxy.$refs.inputUpLoad && (proxy.$refs.inputUpLoad.value = null);
};

// 点击上传
const fileUpload = () => {
  proxy.$refs.inputUpLoad.click();
};

const allFileList = computed({
  get() {
    return [...props.filesObj, ...newFileList.value];
  },
});

const filesId = computed({
  get() {
    return props.filesObj.map((item) => item.id);
  },
});

// 选择文件
const handleFile = (event) => {
  const file = event.target.files;
  let sizeNum =
    props.size - (allFileList.value.length ? allFileList.value.length : 0);
  const length = file.length > sizeNum ? sizeNum : file.length;
  if (file.length > sizeNum) {
    proxy.$refs.inputUpLoad && (proxy.$refs.inputUpLoad.value = null);
    return ElMessage.warning("最多上传" + props.size + "个附件!");
  }
  let valid = true;
  for (let i = 0; i < length; i++) {
    const fName = file[i].name;
    const suffix = fName.substring(fName.lastIndexOf(".") + 1);
    let reg = new RegExp(`^(${props.accept.replace(/,/g, "|")})+$`);
    if (suffix.match(reg)) {
      emits("fileFun", file[i], filesId.value);
      newFileList.value.push(file[i]);
    } else {
      valid &&
        ElMessage.warning(
          `请选择${props.accept.replace(/,/g, "、")}格式的文件!`
        );
      valid = false;
    }
  }
  if (valid && file.length) {
    emits("change", newFileList.value, props.filesObj);
  }
  proxy.$refs.inputUpLoad && (proxy.$refs.inputUpLoad.value = null);
};
</script>

<template>
  <div id="fileUpload">
    <div class="fileBtn" v-if="!showFileList || allFileList.length < size">
      <el-button
        v-loading="loading"
        size="small"
        type="primary"
        icon="Upload"
        @click="fileUpload"
        >{{ text }}
      </el-button>
      <input
        style="display: none"
        ref="inputUpLoad"
        :multiple="Number(size) !== 1"
        type="file"
        accept="*"
        @change="handleFile"
      />
    </div>
    <div v-if="showFileList" class="files">
      <div class="fileName" v-for="(item, i) in allFileList" :key="i">
        <el-row>
          <el-col :span="20" class="fName">
            <span>{{ item.originalName || item.name }}</span>
          </el-col>
          <el-col :span="4">
            <span @click="delFiles(item)" class="fileIcon"
              ><el-icon class="el-icon-delete"> <Delete /> </el-icon
            ></span>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.fileA {
  text-decoration: underline;
  color: #1890ff;
}

// 文件上传样式 start
/deep/ .el-icon-delete {
  position: static;
  right: -150px;
  bottom: 8px;
  font-size: 16px;
}

.files {
  display: block;

  .fileName {
    position: relative;
    padding: 6px 0;

    .fName {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .fileIcon {
      margin-left: 60%;
    }
  }
}
</style>
